import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import RestrictedPage from "./pages/RestrictedPage";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/restricted" element={<RestrictedPage />} />
    </Routes>
  );
}

export default App;
